import React from "react";
import { useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";

export const LogoutButton: React.FC = React.memo(() => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    navigate("/login", { replace: true });
  };

  return (
    <button
      onClick={handleLogout}
      className="flex items-center w-full px-3 py-2 rounded-lg text-red-400 hover:text-red-600 transition"
    >
      <LogOut className="w-5 h-5 mr-2" />
      <span>Logout</span>
    </button>
  );
});
